import HaoPost from './HaoPost';

export default HaoPost;
